@use "@fukuri-admins/ui/layout" as *;

.content {
  display: flex;
  flex-direction: column;
  gap: spacing('24');
  padding: spacing('24');

  &__title {
    @include typography('Jp/20_W6');
    color: text('High');
  }
}

